import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Add Services", -1)
const _hoisted_3 = {
  key: 0,
  class: "specialisms_multiselect_modal_body"
}
const _hoisted_4 = { class: "specialisms_multiselect_modal_search" }
const _hoisted_5 = { class: "specialisms_multiselect_modal_inner no-scrollbar" }
const _hoisted_6 = { class: "specialisms_multiselect_modal_item_heading" }
const _hoisted_7 = { class: "specialisms_multiselect_modal_item_title" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "specialisms_multiselect_modal_item_title_text" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "specialisms_multiselect_modal_item_content" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-center" }, "No Services Found", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "specialisms_multiselect_modal_footer !tw-border-t-dashed-custom !tw-grid tw-grid-cols-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "570px",
    "max-width": "100%",
    persistent: "",
    className: ['specialisms_multiselect_modal']
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_v_icon, {
          icon: "mdi-close",
          class: "close__icon",
          onClick: $setup.onCloseModal
        }, null, 8, ["onClick"])
      ]),
      (!$props.isLoading && !$setup.getCategoryLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_text_field, {
                variant: "outlined",
                placeholder: "Search Specialisms",
                "prepend-inner-icon": "mdi-magnify",
                onInput: $setup.debouncedCategoryFilter
              }, null, 8, ["onInput"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              ($setup.filterCategory?.length)
                ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 0,
                    modelValue: $setup.panel,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.panel) = $event)),
                    multiple: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterCategory, (specialism, index) => {
                        return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_v_checkbox, {
                                    color: "#4B4BFF",
                                    value: specialism.id,
                                    modelValue: $setup.mainCategory,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.mainCategory) = $event)),
                                    onClick: ($event: any) => ($setup.onClickMainCategory(specialism.id))
                                  }, null, 8, ["value", "modelValue", "onClick"]),
                                  _createElementVNode("div", _hoisted_7, [
                                    (specialism.iconName)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "specialisms_multiselect_modal_item_title_icon"
                                        }, {
                                          default: _withCtx(() => [
                                            (specialism.iconName)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: 
                          require('@/assets/category-icons/' +
                            specialism.iconName +
                            '.svg')
                        ,
                                                  alt: "icon"
                                                }, null, 8, _hoisted_8))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_9, [
                                      _createElementVNode("h2", null, _toDisplayString(specialism?.poLabel), 1),
                                      _createElementVNode("p", null, [
                                        _createTextVNode(_toDisplayString(specialism.subCategories
                            .slice(0, 2)
                            .map((sub) => sub.label)
                            .join(", ")) + " ", 1),
                                        (specialism.subCategories?.length > 2)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, " etc.."))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_expansion_panel_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specialism.subCategories, (subCategories) => {
                                    return (_openBlock(), _createBlock(_component_v_checkbox, {
                                      color: "#4B4BFF",
                                      label: subCategories.label,
                                      value: subCategories.id,
                                      modelValue: $setup.selectedCategory,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedCategory) = $event)),
                                      key: subCategories.id
                                    }, null, 8, ["label", "value", "modelValue"]))
                                  }), 128))
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Button, {
                label: "Cancel",
                variant: "secondary",
                onClick: $setup.onCloseModal
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                label: "Save",
                variant: "accent",
                isLoading: $setup.isLoadingForSave,
                onClick: $setup.onClickSaveButton
              }, null, 8, ["isLoading", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_CommonLoader, {
        loading: $props.isLoading || $setup.getCategoryLoader,
        class: "loader-container tw-flex"
      }, null, 8, ["loading"])
    ]),
    _: 1
  }))
}